export function anonymizeFilename(filename: string): string {
  const lastDotIndex = filename.lastIndexOf('.');
  const name = filename.substring(0, lastDotIndex);
  const extension = filename.substring(lastDotIndex + 1);
  const firstLetter = name[0];
  const lastLetter = name[name.length - 1];
  const anonymizedName = `${firstLetter}****${lastLetter}`;
  return `${anonymizedName}.${extension}`;
}
